import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const list = [
  {
    icon: "a",
    title: "Define",
    description:
      "Everything starts with the idea that propel businesses forward. We define your unique selling proposition, risks, and answers for new and existing challenges.",
  },
  {
    icon: "b",
    title: "Design",
    description:
      "We properly shape and visualize your ideas to come true as we transform your vision into smart human-centered products that have a lasting impact and improve user engagement.",
  },
  {
    icon: "c",
    title: "Develop",
    description:
      "Our team follows best practices such as agile development and continuous integration and deployment to ensure that the product is delivered on time and within budget.",
  },
  {
    icon: "d",
    title: "Grow",
    description:
      "The key to sustainable growth lies in the right people with a clear North Star. We augment businesses with reliable guidance, support, and scalable solutions.",
  },
];

const Approach = () => {
  return (
    <Box padding={{ xs: "15% 0%", sm: "2% 0%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        width={{ xs: "100%", sm: "75%" }}
        flexWrap={"wrap"}
        marginLeft={{ xs: "0%", sm: "25%" }}
      >
        {list.map((lists, id) => (
          <Box
            key={id}
            width={{ xs: "100%", sm: "40%" }}
            marginTop={{ xs: "10%", sm: "2%" }}
            padding={{ xs: "2%", sm: "1%" }}
            data-aos={"fade-up"}
          >
            <Divider color={"#000"} paddingTop={"3%"} />
            <Typography
              variant={"body1"}
              fontWeight={500}
              textAlign={"left"}
              paddingTop={"5%"}
              color={"#000"}
            >
              {lists.icon}
            </Typography>
            <Typography
              variant={"h5"}
              fontWeight={700}
              textAlign={"left"}
              paddingTop={"2%"}
              color={"#000"}
            >
              {lists.title}
            </Typography>
            <Typography
              variant={"body1"}
              fontWeight={500}
              textAlign={"left"}
              paddingTop={"2%"}
              paddingBottom={"2%"}
              color={"#000"}
            >
              {lists.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Approach;
